import Spinner from '~/components/Spinner';

const Buffering = () => (
  <div class="flex w-screen h-screen bg-neutral-bg-primary/80 justify-center items-center">
    <Spinner />
  </div>
);

export default Buffering;
